<template>
    <div onafterprint="closeTab">
        <section>
            <el-col :lg="24" class="case-vote-temp">
                <template>
                    <el-tabs type="card" v-model="activeName" @tab-click="handleClick" class="cust-tabs" v-if="showTabs">
                    <!-- v-if="showTabs" -->
                        <el-tab-pane name="stage_1">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Case Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="stage_2" :disabled="caseDetails.status_key == 'stage_1'" v-if="$store.state.config.user.role_slug.indexOf('fachstellen') < 0 && caseDetails.status_key != 'stage_3'">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Vote Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="stage_3" :disabled="caseDetails.status_key == 'stage_1'" v-if="$store.state.config.user.role_slug==='main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user'">
                            <div slot="label" class="tab-panel">
                                <div class="tab-name">
                                    <p class="nm"> {{ $t("Review Details") }}</p>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>

                    <!-- <i class="el-icon-chat-dot-round nm chat-icon" @click="chat.drawer = true"></i> -->
                    <div class="chat-box" v-if="($store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user' || $store.state.config.user.role_slug == 'fachstellen-user' || $store.state.config.user.role_slug == 'fachstellen') && this.caseDetails.status_key == 'rejected'">
                        <i class="el-icon-chat-dot-round nm chat-icon" @click="openCloseChat(chat.drawer)"></i>
                        <span style="color:#9096AB">{{ this.chatTitle }}</span>
                    </div>                           
                </template>
            </el-col>
        </section>
        <div v-if="($store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user' || $store.state.config.user.role_slug == 'fachstellen-user' || $store.state.config.user.role_slug == 'fachstellen') && this.caseDetails.status_key == 'rejected'">
           <el-drawer
            :visible.sync="chat.drawer"
            :direction="chat.direction" class="chat-box">
            <div class="header">
                <h1>{{$t("Discussion")}}</h1>
            </div>
            <el-row type="flex">
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-row>
                            <el-col>
                                <el-card class="box-card comment-box">
                                    <div class="avatar-dev">
                                        <span class="avatar-icon">
                                            <img :src="$store.state.config.user.profile_image || '/static/default_user.svg'" alt="user-avatar" />
                                        </span>
                                    </div>
                                    <el-form ref="chatForm" :model="chatForm" id="chatForm">
                                        <el-form-item prop="chatDesc" :rules="[{ required: true, message: $t('This field is required')}]" class="comment-textbox">
                                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 40}" :placeholder="$t('What\'s on your mind?')" v-model="chatForm.chatDesc"></el-input>
                                        </el-form-item>
                                        <el-form-item class="btn-add-comment">
                                            <el-button size="mini" type="primary" @click="addComment('chatForm')">
                                                {{$t("Add comment")}}
                                            </el-button>
                                        </el-form-item>
                                    </el-form>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row v-if="caseChats.length > 0">
                            <el-col id="comment-sec">
                                <el-card class="box-card reply-box" v-for="(caseChat) in caseChats" :key="caseChat.id">
                                    <div :class="{chatUser1: caseChat.user_id === $store.state.config.user.id, chatUser2: caseChat.user_id !== $store.state.config.user.id}">
                                    <el-dropdown @command="handleCommand" class="operations" trigger="click" v-if="caseDetails.status_key == 'stage_2' && ((caseChat.user_id == $store.state.config.user.id) || ($store.state.config.user.role_id == 1))">
                                        <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="{type:'edit', row: caseChat}"><i class="el-icon-edit"></i>
                                                {{ $t('Edit') }}</el-dropdown-item>
                                            <el-dropdown-item :command="{type:'delete', row: caseChat}"><i class="el-icon-delete"></i>
                                                {{ $t('Delete') }}</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <div class="avatar-dev">
                                        <span class="avatar-icon">
                                            <img :src="caseChat.profile_image || '/static/default_user.svg'" alt="user-avatar" />
                                        </span>
                                        <p class="user-name">{{ caseChat.user_name }} <span class="comment-duration" v-date-time-format="caseChat.created_at"></span></p>
                                    </div>
                                    <div class="comment-div">
                                        <el-input v-if="caseChat.edit" type="textarea" v-model="caseChat.comment"></el-input>
                                        <p v-else v-html="$options.filters.nl2br(caseChat.comment)"></p>
                                        <div class="replied-box">
                                            <el-button v-if="caseChat.edit" type="success" @click="confirmEdit(caseChat)" size="mini" icon="el-icon-check" circle></el-button>
                                            <el-button v-if="caseChat.edit" class='cancel-btn' size="mini" icon="el-icon-close" type="warning" @click="cancelEdit(caseChat)" circle></el-button>
                                        </div>
                                    </div>
                                    <div class="reply-comments" v-if="caseChat.children">
                                        <el-card class="box-card" v-for="commentReply in caseChat.children" :key="commentReply.id">
                                            <div class="comment-box" style="background-color: red">
                                                <el-dropdown @command="handleCommand" class="operations" trigger="click" v-if="caseDetails.status_key == 'stage_2' && ((commentReply.user_id == $store.state.config.user.id) || ($store.state.config.user.role_id == 1))">
                                                    <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item :command="{type:'edit', row: commentReply}"><i class="el-icon-edit"></i>
                                                            {{ $t('Edit') }}</el-dropdown-item>
                                                        <el-dropdown-item :command="{type:'delete', row: commentReply}"><i class="el-icon-delete"></i>
                                                            {{ $t('Delete') }}</el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                                <div class="avatar-dev">
                                                    <span class="avatar-icon">
                                                        <img :src="commentReply.profile_image || '/static/default_user.svg'" alt="user-avatar" />
                                                    </span>
                                                    <p class="user-name">{{ commentReply.user_name }} <span class="comment-duration" v-date-time-format="commentReply.created_at"></span></p>
                                                </div>
                                                <div class="comment-div">
                                                    <span>
                                                        <el-input v-if="commentReply.edit" type="textarea" v-model="commentReply.comment"></el-input>
                                                        <p v-else v-html="$options.filters.nl2br(commentReply.comment)"></p>
                                                        <div class="replied-box">
                                                            <el-button v-if="commentReply.edit" type="success" @click="confirmEdit(commentReply)" size="mini" icon="el-icon-check" circle></el-button>
                                                            <el-button v-if="commentReply.edit" class='cancel-btn' size="mini" icon="el-icon-close" type="warning" @click="cancelEdit(commentReply)" circle></el-button>
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </el-card>
                                    </div>
                                    <!-- <a v-if="caseDetails.status_key == 'stage_2'" href="javascript:void(0)" @click="caseChat.reply = !caseChat.reply" class="reply-link">{{
                                        $t('Reply') }}</a>
                                    <div class="replyForm" v-if="caseChat.reply == true">
                                        <el-form :ref="'replyForm-'+caseChat.id" :model="caseChat.replyForm" id="replyForm">
                                            <el-form-item prop="commentDesc" :rules="[{ required: true, message: $t('This field is required')}]">
                                                <el-input type="textarea" autosize :placeholder="$t('Want to reply?')" v-model="caseChat.replyForm.commentDesc"></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div> -->
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row v-else>
                            <el-col id="comment-sec">
                                <el-card class="box-card reply-box">
                                    <p class="no-discuss">{{ $t('There is no discussion started.') }}</p>
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-col>
            </el-row>
            </el-drawer>
        </div>
        <el-row :gutter="12" class="grid-stack-item">
            <div class="my-content"  id="printableArea">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"  >
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="header" >
                        <h1 id="header-title">{{ $t('Case Details') }}</h1>
                         <!-- <ul class="icon-list" v-if="($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user' || $store.state.config.user.role_slug == 'fachstellen-user' || $store.state.config.user.role_slug == 'fachstellen')"> -->
                        <ul class="icon-list" v-if="($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'fachstellen-user' || $store.state.config.user.role_slug == 'fachstellen')">
                            <li><a id="pdf-icon" @click="printDiv('printableArea')" href="javascript:void(0)" style="color:var(--white-color)" :title="$t('Print')">{{ $t('DOWNLOAD') }}  <i class="el-icon-download"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row">
                                <div class="action-list">
                                    <el-tag size="small" :type="getStatusType(caseDetails.status_key)" v-if="caseDetails.is_new_case==0">
                                        {{ $t(caseDetails.status_key) }}
                                    </el-tag>
                                     <el-tag size="small" type="danger" v-else>
                                        <h4> {{ $t('Erstaufnahme')}} </h4>
                                    </el-tag>
                                    <ul class="act-list case-act-list" v-if="caseDetails.status_key && caseDetails.status_key != 'donated' && caseDetails.status_key != 'stage_1' && ($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user')">
                                        <li>
                                            <el-button size="mini" class="reopenButton" type="danger" @click="reOpenCase();">{{$t('Re-open')}}</el-button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Title') }}</h3>
                                    <p>{{ caseDetails.case_title }}</p>
                                </div>
                            </div>
                            <div class="card-row">
                                <div class="left-border-list">
                                    <h3>{{ $t('Created on') }}</h3>
                                    <p v-date-time-format="caseDetails.created_at"></p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Expected amount') }}</h3>
                                    <p>{{ caseDetails.expected_amount | currency-format }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Fachstellen Name') }}</h3>
                                    <p>{{ caseDetails.fachstellen_name }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Fachstellen Person Name') }}</h3>
                                    <p>{{ caseDetails.creator_name }}</p>
                                </div>
                                <div class="left-border-list" v-if="caseDetails.payment_slip_doc && $store.state.config.user.role_slug != 'club-user'">
                                    <h3>{{ $t('Documents')   }}</h3>
                                    <p v-for="(images, i) in caseDetails.payment_slip_doc" :key="images.id"><a style="text-decoration:underline"  target="_blank" :href="images.payment_slip">{{ images.payment_slip_name.substring(images.payment_slip_name.indexOf('-')+1) }}</a></p>
                                </div>
                                <!-- <div class="left-border-list" v-if="caseDetails.description">
                                    <h3>{{ $t('Anonymised description of the application (application details, deductible, benefit for the child)') }}</h3>
                                    <p>{{ caseDetails.description }}</p>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Support requested') }}</h1>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <el-table :data="caseDetails.additions" style="width: 100%">
                                <el-table-column prop="reason" :label="$t('What')" width="250" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column align="right" prop="cost" :label="$t('Cost')" width="180">
                                    <template slot-scope="scope">
                                        {{scope.row.cost | currency-format}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="category_name" :label="$t('Categories')" width="250" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column min-width="10" label=" ">
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Patenkinder Details') }}</h1>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row table-desc">
                                <div class="action-list">
                                    <label for="status" :class="(patenkindDetails.status == 'active'? 'act': 'in-act')">{{
                                        $t(patenkindDetails.status) }}</label>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Patenkinder Name') }}</h3>
                                    <p v-if="patenkindDetails.patenkinder_slug && $store.state.config.user.role_slug.indexOf('club') < 0">
                                        <router-link :to="{ name: 'PatenkindDetails', params:{ patenkind_slug:patenkindDetails.patenkinder_slug } }">
                                            {{ patenkindDetails.display_name }}
                                        </router-link>
                                    </p>
                                    <p v-else>    
                                        {{ patenkindDetails.display_name }}
                                    </p>
                                </div>
                            </div>
                            <div class="card-row">
                                <div class="left-border-list" v-if="$store.state.config.user.role_slug.indexOf('fachstellen') >= 0">
                                    <h3>{{ $t('Initials of the godchild (e.g. A.Z.)') }}</h3>
                                    <p>{{ patenkindDetails.nick_name }}</p>
                                </div>
                                <div class="left-border-list" v-if="$store.state.config.user.role_slug.indexOf('club') < 0">
                                    <h3>{{ $t('DOB') }}</h3>
                                    <p><span v-date-format="patenkindDetails.dob"></span></p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Age') }}</h3>
                                    <p>{{ patenkindDetails.age }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Place') }}</h3>
                                    <p>{{ patenkindDetails.place }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Origin country') }}</h3>
                                    <p>{{ patenkindDetails.origin_country }}</p>
                                </div>
                                <div class="left-border-list">
                                    <h3>{{ $t('Fachstellen Name') }}</h3>
                                    <p>{{ patenkindDetails.fachstellen_name }}</p>
                                </div>
                                <div class="left-border-list full-list">
                                    <h3>{{ $t('Remarks of the Office') }}</h3>
                                    <p>{{ caseDetails.remark }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="caseDetails.status_key == 'donated'">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Confirmed amount and its description') }}</h1>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row">
                                <div class="left-border-list full-list">
                                    <h4> {{ caseDetails.approved_amount | currency-format }}</h4>
                                </div>
                                <div class="left-border-list full-list">
                                    <p v-html="$options.filters.nl2br(caseDetails.remark)"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="(caseDetails.description)">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Description of the application') }}</h1>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row">
                                <div class="left-border-list full-list">
                                    <p v-html="$options.filters.nl2br(caseDetails.description)"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="caseDetails.org_description != null && $store.state.config.user.role_slug.indexOf('fachstellen') < 0">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Voting note') }}</h1>
                        <ul class="icon-list" v-if="($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user')">
                            <li v-if="caseDetails.edit"><a @click="confirmEdit(caseDetails)" href="javascript:void(0)"
                                    :title="$t('Save')"><i class="el-icon-check"></i></a></li>
                            <li v-if="caseDetails.edit"><a @click="cancelEdit(caseDetails)" href="javascript:void(0)"
                                    :title="$t('Cancel')"><i class="el-icon-close"></i></a></li>
                            <li v-else><a @click="handleEdit(caseDetails)" href="javascript:void(0)" :title="$t('Edit')"><i
                                        class="el-icon-edit"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row">
                                <div class="left-border-list full-list">
                                    <el-input v-if="caseDetails.edit" type="textarea" v-model="caseDetails.org_description"></el-input>
                                    <p v-else v-html="$options.filters.nl2br(caseDetails.org_description)"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <!-- v-if="$store.state.config.user.role_slug != 'club-user'" -->
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Criteria for supporting the godchild') }}</h1>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row">
                                <div class="left-border-list full-list">
                                    <h3>{{ $t('It can be ensured that the support lines benefit only the child.') }}</h3>
                                    <p>
                                        <el-tag :type="caseDetails.q_ans_1 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(caseDetails.q_ans_1)"
                                            size="mini"></el-tag><br><span v-if="caseDetails.ans_1_description" v-html="$options.filters.nl2br(caseDetails.ans_1_description)"></span>
                                    </p>
                                </div>
                                <div class="left-border-list full-list">
                                    <h3>{{ $t('The payment is made via a specialist office or with a direct payment slip (eg bill music school).') }}</h3>
                                    <p>
                                        <el-tag :type="caseDetails.q_ans_2 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(caseDetails.q_ans_2)"
                                            size="mini"></el-tag><br><span v-if="caseDetails.ans_2_description" v-html="$options.filters.nl2br(caseDetails.ans_2_description)"></span>
                                    </p>
                                </div>
                                <div class="left-border-list full-list">
                                    <h3>{{ $t('It is ensured that no other organization (public sector, insurance, etc.) would have to pay for the neediness?') }}</h3>
                                    <p>
                                        <el-tag :type="caseDetails.q_ans_3 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(caseDetails.q_ans_3)"
                                            size="mini"></el-tag><br><span v-if="caseDetails.ans_3_description" v-html="$options.filters.nl2br(caseDetails.ans_3_description)"></span>
                                    </p>
                                </div>
                                <div class="left-border-list full-list">
                                    <h3>{{ $t('The support service promotes the integration of the child into its environment / society (eg supporting activities with other children).') }}</h3>
                                    <p>
                                        <el-tag :type="caseDetails.q_ans_4 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(caseDetails.q_ans_4)"
                                            size="mini"></el-tag><br><span v-if="caseDetails.ans_4_description" v-html="$options.filters.nl2br(caseDetails.ans_4_description)"></span>
                                    </p>
                                </div>
                                <div class="left-border-list full-list" v-if="caseDetails.ans_5_description">
                                    <h3>{{ $t('Payment instructions:') }}</h3>
                                    <p>
                                        <span v-if="caseDetails.ans_5_description" v-html="$options.filters.nl2br(caseDetails.ans_5_description)"></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>                
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="caseDetails.status_key == 'rejected'">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Reject case description') }}</h1>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row">
                                <div class="left-border-list full-list">
                                    <p v-html="$options.filters.nl2br(caseDetails.remark)"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="caseDetails.status_key == 'stage_3'">
                    <div class="header">
                        <h1 id="header-title">{{ $t('Skip vote description') }}</h1>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <div class="card-row">
                                <div class="left-border-list full-list">
                                    <p v-html="$options.filters.nl2br(caseDetails.remark)"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24" class="appDetailButtons" v-if="caseDetails.status_key == 'stage_1' && ($store.state.config.user.role_slug == 'main-admin' || $store.state.config.user.role_slug == 'organization' || $store.state.config.user.role_slug == 'organization-user')">
                    <el-button type="cancel" @click="votingNoteDialog = true">{{$t('Vote now')}}</el-button>
                    <el-button type="primary" :disabled="(caseDetails.is_new_case !== 0 ) === true" class="mobileViewButton" @click="skipVotePopUp()">{{$t('Skip Voting')}}</el-button>
                    <el-button type="danger" @click="rejectCasePopUp()">{{$t('Reject case')}}</el-button>
                </el-col>
            </el-col>
            
            <el-dialog :title="$t('Reject case')" :visible.sync="dialogFormVisible">
                <el-form :model="form" ref="formData">
                    <el-form-item :label="$t('Description')" prop="remark" :rules="[{ required: true, message: $t('This field is required')}]">
                        <el-input type="textarea" v-model="form.remark"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="isLoading" @click="rejectCase('formData',0)"> {{
                            $t('Reject') }} </el-button>
                        <el-button type="primary" :loading="isLoading" @click="rejectCase('formData',1)">
                            {{ $t('Reject and send email') }} </el-button>
                        <el-button type="cancel" @click="dialogFormVisible = false">{{$t('Cancel')}}</el-button>
                    </el-form-item>
                    <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                </el-form>
            </el-dialog>
            <el-dialog :title="$t('Voting note')" :visible.sync="votingNoteDialog">
                <el-form :model="votingNoteForm" ref="votingNoteForm">
                    <el-form-item :label="$t('Description1')" prop="org_description">
                        <el-input type="textarea" :autosize="{ minRows:2, maxRows: 20 }" v-model="votingNoteForm.org_description"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="isLoading" @click="voteNow('votingNoteForm')">{{$t('Save')}}</el-button>
                        <el-button type="cancel" @click="votingNoteDialog = false">{{$t('Cancel')}}</el-button>
                    </el-form-item>
                    <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                </el-form>
            </el-dialog>
            <el-dialog :title="$t('Why skip voting?')" :visible.sync="skipVoteDialog">
                <el-form :model="skipVoteForm" ref="skipVoteForm">
                    <!-- :label="$t('Description')"  -->
                    <el-form-item prop="remark">
                        <el-input type="textarea" v-model="skipVoteForm.remark"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="isLoading" @click="skipVote('skipVoteForm')">{{$t('Save')}}</el-button>
                        <el-button type="cancel" @click="skipVoteDialog = false">{{$t('Cancel')}}</el-button>
                    </el-form-item>
                    <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
                </el-form>
            </el-dialog>
            </div>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" id="past-case">
                    <div class="header">
                        <h1>{{ $t('Past Cases') }}</h1>
                    </div>
                    <div class="my-content" v-if="caseDetails && caseDetails.patenkinder_slug">
                        <div class="grid-stack-item-content">
                            <patenkind-cases :patenkind_slug="caseDetails.patenkinder_slug"/>
                        </div>
                    </div>
                </el-col>
        </el-row>
        <div id="pdfDiv" hidden>
            <table style="position:relative;display:block;width:285mm;margin-bottom: 10px;">
                <tbody>
                    <tr>
                        <td style="text-align: left;padding: 10px;background-color: #757575; ;text-transform: uppercase;font-weight: bold; ">
                            <table style="width: 285mm;">
                                <tr>
                                    <td style="border-left: 2px solid #FFFFFF;padding-left: 5px; color: #ffffff;font-size: 16px;">
                                        {{ $t('Case Details') }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="width: 285mm;">
                <tbody>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Title') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ caseDetails.case_title }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="font-size: 14px;">
                                        <span style="border-radius: 10px;padding: 5px 10px;display:inline-block;height: auto;" :class="getStatusTypePdf(caseDetails.status_key)" v-if="caseDetails.is_new_case==0">{{ $t(caseDetails.status_key) }}</span>
                                        <span style="border-radius: 10px;padding: 5px 10px;display:inline-block;" class="el-tag el-tag--danger el-tag--small el-tag--light" v-else>{{ $t('Erstaufnahme')}}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Created on') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ caseDetails.created_at }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Expected amount') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ caseDetails.expected_amount }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Fachstellen Name') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ caseDetails.fachstellen_name }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Fachstellen Person Name') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ caseDetails.creator_name }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;" v-if="caseDetails.payment_slip_doc && $store.state.config.user.role_slug != 'club-user'">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('upload an invoice with a payment slip.') }}</span>
                                        <span v-for="(images, i) in caseDetails.payment_slip_doc" :key="images.id" style="color: #757575;display: block;text-transform: capitalize;">{{ images.payment_slip_name.substring(images.payment_slip_name.indexOf('-')+1) }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="position:relative;display:block;width:285mm;margin-bottom: 10px;">
                <tbody>
                    <tr>
                        <td style="text-align: left;padding: 10px;background-color: #757575; ;text-transform: uppercase;font-weight: bold; ">
                            <table style="width: 285mm;">
                                <tr>
                                    <td style="border-left: 2px solid #FFFFFF;padding-left: 5px; color: #ffffff;font-size: 16px;">
                                        {{ $t('Patenkinder Details') }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="width: 285mm;">
                <tbody>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Patenkinder Name') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ patenkindDetails.display_name }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="font-size: 14px;">
                                        <label style="color: #fff;padding: 5px 10px;display:inline-block;height: auto;line-height: 22px;" :class="(patenkindDetails.status == 'active'? 'act': 'in-act')">{{ $t(patenkindDetails.status) }}</label>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('DOB') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;"><span v-date-format="patenkindDetails.dob"></span></span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Age') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ patenkindDetails.age }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Place') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ patenkindDetails.place }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Origin country') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ patenkindDetails.origin_country }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Fachstellen Name') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ patenkindDetails.fachstellen_name }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Remarks of the Office') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ patenkindDetails.office_comments }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="position:relative;display:block;width:285mm;margin-bottom: 10px;">
                <tbody>
                    <tr>
                        <td style="text-align: left;padding: 10px;background-color: #757575; ;text-transform: uppercase;font-weight: bold; ">
                            <table style="width: 285mm;">
                                <tr>
                                    <td style="border-left: 2px solid #FFFFFF;padding-left: 5px; color: #ffffff;font-size: 16px;">
                                        {{ $t('Support requested') }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="width: 285mm;" cellspacing="0" cellpadding="0">
                <tbody>
                    <tr>
                        <td style="width: 33.33%;padding: 5px 0px 5px 10px;">
                            <table style="width: 100%;" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="font-size: 14px;">
                                        <span style="font-weight: bold;background:#cececd;padding:5px 10px; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('What') }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 33.33%;padding: 5px 0px;">
                            <table style="width: 100%;" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="font-size: 14px;text-align:right;">
                                        <span style="font-weight: bold;background:#cececd;padding:5px 10px; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Cost') }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 33.33%;padding: 5px 10px 5px 0;">
                            <table style="width: 100%;" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="font-size: 14px;">
                                        <span style="font-weight: bold;background:#cececd;padding:5px 10px; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Categories') }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr v-for="data in caseDetails.additions" :key="data.id">
                        <td style="width: 33.33%;padding: 5px 0px 5px 10px;">
                            <table style="width: 100%;" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="font-size: 14px;">
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ data.reason }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 33.33%;padding: 5px 0px;">
                            <table style="width: 100%;" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="font-size: 14px;text-align:right;">
                                        <span style="color: #757575;display: block;padding-right:10px;text-transform: capitalize;">{{ data.cost | currency-format }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 33.33%;padding: 5px 10px 5px 0;">
                            <table style="width: 100%;" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td style="font-size: 14px;">
                                        <span style="color: #757575;display: block;padding-left:10px;text-transform: capitalize;">{{ data.category_name }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>           
                </tbody>
            </table>

            <table style="position:relative;display:block;width:285mm;margin-bottom: 10px;">
                <tbody>
                    <tr>
                        <td style="text-align: left;padding: 10px;background-color: #757575; ;text-transform: uppercase;font-weight: bold; ">
                            <table style="width: 285mm;">
                                <tr>
                                    <td style="border-left: 2px solid #FFFFFF;padding-left: 5px; color: #ffffff;font-size: 16px;">
                                        {{ $t('Description of the application') }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="width: 285mm;">
                <tbody>
                    <tr>
                        <td style="width: 50%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="color: #757575;display: block;text-transform: capitalize;">{{ $options.filters.nl2br(caseDetails.description) }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;
                        </td>
                    </tr>
                </tbody>
            </table>


            <table style="position:relative;display:block;width:285mm;margin-bottom: 10px;">
                <tbody>
                    <tr>
                        <td style="text-align: left;padding: 10px;background-color: #757575; ;text-transform: uppercase;font-weight: bold; ">
                            <table style="width: 285mm;">
                                <tr>
                                    <td style="border-left: 2px solid #FFFFFF;padding-left: 5px; color: #ffffff;font-size: 16px;">
                                        {{ $t('Criteria for supporting the godchild') }}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="width: 285mm;">
                <tbody>
                    <tr>
                        <td style="width: 100%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('It can be ensured that the support lines benefit only the child.') }}</span>
                                        <span :class="caseDetails.q_ans_1 == 'yes' ? 'el-tag el-tag--success el-tag--mini el-tag--light' : 'el-tag el-tag--danger el-tag--mini el-tag--light'" style="display: inline-block;text-transform: capitalize;height: auto;line-height: 19px;height: 20px;" v-if="caseDetails.q_ans_1">{{ caseDetails.q_ans_1 }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 100%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('The payment is made via a specialist office or with a direct payment slip (eg bill music school).') }}</span>
                                        <span :class="caseDetails.q_ans_2 == 'yes' ? 'el-tag el-tag--success el-tag--mini el-tag--light' : 'el-tag el-tag--danger el-tag--mini el-tag--light'" style="display: inline-block;text-transform: capitalize;height: auto;line-height: 19px;height: 20px;" v-if="caseDetails.q_ans_2">{{ caseDetails.q_ans_2 }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 100%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('It is ensured that no other organization (public sector, insurance, etc.) would have to pay for the neediness?') }}</span>
                                        <span :class="caseDetails.q_ans_3 == 'yes' ? 'el-tag el-tag--success el-tag--mini el-tag--light' : 'el-tag el-tag--danger el-tag--mini el-tag--light'" style="display: inline-block;text-transform: capitalize;height: auto;line-height: 19px;height: 20px;" v-if="caseDetails.q_ans_3">{{ caseDetails.q_ans_3 }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 100%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('The support service promotes the integration of the child into its environment / society (eg supporting activities with other children).') }}</span>
                                        <span :class="caseDetails.q_ans_4 == 'yes' ? 'el-tag el-tag--success el-tag--mini el-tag--light' : 'el-tag el-tag--danger el-tag--mini el-tag--light'" style="display: inline-block;text-transform: capitalize;height: auto;line-height: 19px;height: 20px;" v-if="caseDetails.q_ans_4">{{ caseDetails.q_ans_4 }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr v-if="caseDetails.ans_5_description">
                        <td style="width: 100%;padding: 5px 10px;">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="border-left: 2px solid #757575;padding-left: 5px;font-size: 14px;">
                                        <span style="font-weight: bold; color: #464644;display: block;margin-bottom: 3px;text-transform: uppercase;">{{ $t('Payment instructions:') }}</span>
                                        <span style="color: #757575;display: block;text-transform: capitalize;" v-if="caseDetails.ans_5_description">{{ $options.filters.nl2br(this.caseDetails.ans_5_description) }}</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style lang="scss">

    @media only screen and (max-width:414px) {
        .el-button.el-button--danger {
            margin: 10px 0 0 0;
        }
        .reopenButton{
            margin:0 !important ;
        }
        .mobileViewButton{
            margin : 10px 0 0 0 !important;
        }
    }

    @media only screen and (max-width:320px) {
        .el-button+.el-button {
            margin-left: 0;
        }

        .el-button.el-button--danger {
            margin: 10px 0 0 10px;
        }
        .reopenButton{
            margin:0 !important ;
        }
    }
    @media print {
        @page { margin: 0; }
        body { size: auto;margin: 1cm; }
        #header-title {
            color: #575757 !important;
            right: 30px;
        }
        #pdf-icon {
            display: none;
        }
        .case-act-list{
            display: none;
        }
    }
</style>

<script>
    import PatenkindCases from "./PatenkindCases";
    const { jsPDF } = require("jspdf");
    import html2canvas from 'html2canvas';
    export default {
        components: {
            PatenkindCases
        },
        data() {
            return {
                caseDetails: {},
                patenkindDetails: {},
                status: null,
                dialogFormVisible: false,
                form: {},
                votingNoteDialog: false,
                votingNoteForm: {},
                skipVoteDialog: false,
                skipVoteForm: {},
                activeName: 'stage_1',
                isLoading: false,
                currentRow: {},
                dummyRow: {},
                showTabs: false,
                chat: {
                    drawer: false,
                    direction: 'rtl',
                },
                chatTitle : '',
                caseChats: {},
                chatForm: {}
            };
        },
        mounted() {
            request({
                    url: "patenkinder-cases/" + this.$route.params.id,
                    method: "get",
                    params: {}
                })
                .then(response => {
                    if (this.$store.state.config.user.role_slug === 'organization' || this.$store.state.config.user.role_slug === 'organization-user') {
                        this.chatTitle = this.$t('Chat with Social unit')
                    } else if(this.$store.state.config.user.role_slug === 'fachstellen-user' || this.$store.state.config.user.role_slug === 'fachstellen') {
                        this.chatTitle = this.$t('Chat with Orgaisation Admin')
                    }
                    this.caseDetails = response.data.data;
                    this.$set(this.caseDetails, 'edit', false);
                    this.showTabs = true;
                    if (this.caseDetails.patenkinder_slug)
                        request({
                            url: "patenkinders/" + this.caseDetails.patenkinder_slug,
                            method: "get",
                            params: {}
                        })
                        .then(response => {
                            this.patenkindDetails = response.data.data;
                        });
                });
                request({
                    url: "case/" + this.$route.params.id + "/comments" + "?is_admin=1",
                    method: "get"
                })
                .then(response => {
                    if (this.$route.query.chat) {
                        this.chat.drawer = true
                    }
                    this.caseChats = response.data.data;
                    this.setEditAtt();
                });
                 this.socket = io(process.env.KIPAKI_SOCKET_URL, {
                reconnectionAttempts: 1,
            });
            this.socket.on(`case_chat_${this.$route.params.id}:App\\Events\\CaseComment\\CaseCommentAdded`, data => {
                if (data.commentData.parent_id == null) {
                    this.caseChats.push(Object.assign({}, data.commentData));
                } else {
                    this.caseChats.forEach((row, i) => {
                        if (row.id == data.commentData.parent_id) {
                            row.children.push(Object.assign({}, data.commentData));
                        }
                    });
                }
                this.setEditAtt();
            });
            this.socket.on(`case_chat_${this.$route.params.id}:App\\Events\\CaseComment\\CaseCommentUpdated`, data => {
                if (data.commentData.parent_id == null) {
                    this.caseChats = this.caseChats.map((row, i) => {
                        if (row.id == data.commentData.id) {
                            row = data.commentData;
                        }
                        return row;
                    });
                } else {
                    this.caseChats = this.caseChats.map((row) => {
                        if (row.id == data.commentData.parent_id && row.children.length > 0) {
                            row.children = row.children.map((childrow) => {
                                if (childrow.id == data.commentData.id) {
                                    childrow = data.commentData;
                                }
                                return childrow;
                            });
                        }
                        return row;
                    });
                }
                this.setEditAtt();
            });
            this.socket.on(`case_chat_${this.$route.params.id}:App\\Events\\CaseComment\\CaseCommentDeleted`, data => {
                if (data.commentData.parent_id == null) {
                    this.caseChats = this.caseChats.filter((row, i) => {
                        return row.id != data.commentData.id;
                    });
                } else {
                    this.caseChats = this.caseChats.filter((res) => {
                        if (res.children.length > 0 && data.commentData.id != res.id) {
                            res.children = res.children.filter((child) => {
                                return child.id != data.commentData.id
                            });
                        }
                        return res.id != data.commentData.id;
                    });
                }
                this.setEditAtt();
            });
        },
        methods: {
            handleEdit(row) {
                this.cancelEdit(this.dummyRow)
                this.currentRow = Object.assign({}, row);
                this.dummyRow = row;
                row.edit = !row.edit;
            },
            cancelEdit(row) {
                row.edit = false;
                Object.assign(row, this.currentRow);
            },
            confirmEdit(row) {
                row.edit = false
                request({
                    url: "patenkinder-cases/" + this.$route.params.id,
                    method: "PATCH",
                    data: row
                }).then(response => {
                    Object.assign(row, response.data.data);
                    this.currentRow = Object.assign({}, row);
                    this.$notify({
                        title: this.$t('Success'),
                        message: response.data.message,
                        type: 'success',
                        offset: 50
                    })
                }).catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.error.message,
                        type: "error",
                        offset: 50
                    });
                });
            },
            getStatusType(status_key) {
                var statusType = '';
                switch (status_key) {
                    case 'stage_1':
                        statusType = 'info';
                        break;
                    case 'stage_2':
                        statusType = 'warning'
                        break;
                    case 'stage_3':
                        statusType = '';
                        break;
                    case 'donated':
                        statusType = 'success';
                        break;
                    default:
                        statusType = 'danger';
                }
                return statusType;
            },
            getStatusTypePdf(status_key) {
                var statusType = '';
                switch (status_key) {
                    case 'stage_1':
                        statusType = 'el-tag el-tag--info el-tag--small el-tag--light';
                        break;
                    case 'stage_2':
                        statusType = 'el-tag el-tag--warning el-tag--small el-tag--light'
                        break;
                    case 'stage_3':
                        statusType = '';
                        break;
                    case 'donated':
                        statusType = 'el-tag el-tag--success el-tag--small el-tag--light';
                        break;
                    default:
                        statusType = 'el-tag el-tag--danger el-tag--small el-tag--light';
                }
                return statusType;
            },
            handleClick(tab, event) {
                if (tab.name == "stage_1") {
                    this.$router.push({
                        name: 'CaseDetails',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                } else if (tab.name == "stage_2") {
                    this.$router.push({
                        name: 'CaseVoting',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'CaseReview',
                        params: {
                            id: this.$route.params.id
                        }
                    })
                }
            },
            voteNow(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                                url: "update-case-status",
                                method: "post",
                                data: {
                                    case_id: this.$route.params.id,
                                    status: 'stage_2',
                                    org_description: this.votingNoteForm.org_description
                                }
                            })
                            .then(response => {
                                this.isLoading = false;
                                this.votingNoteDialog = false;
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: this.$t('Case added for club voting successfully!'),
                                    type: "success",
                                    offset: 50
                                });
                                this.$router.push({
                                    name: 'CaseVoting',
                                    params: {
                                        id: this.$route.params.id
                                    }
                                })
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                                this.isLoading = false;
                            });
                    }
                });
            },
            skipVotePopUp() {
                this.$confirm(
                    this.$t('Are you sure want to skip voting for this case?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    this.skipVoteDialog = true;
                }).catch(() => {});
            },
            skipVote(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                                url: "update-case-status",
                                method: "post",
                                data: {
                                    case_id: this.$route.params.id,
                                    status: 'stage_3',
                                    remark: this.skipVoteForm.remark
                                }
                            })
                            .then(response => {
                                this.isLoading = false;
                                this.skipVoteDialog = false;
                                this.$router.push({
                                    name: 'CaseReview',
                                    params: {
                                        id: this.$route.params.id
                                    }
                                })
                            });
                    }
                });
            },
            rejectCase(formName, isEmail) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.isLoading = true;
                        request({
                            url: "update-case-status",
                            method: "post",
                            data: {
                                case_id: this.$route.params.id,
                                status: 'rejected',
                                remark: this.form.remark,
                                send: isEmail
                            }
                        }).then(response => {
                            this.isLoading = false;
                            this.$router.push({
                                name: 'Cases'
                            });
                            this.$notify({
                                title: this.$t('Success'),
                                message: this.$t('Case rejected!'),
                                type: "success",
                                offset: 50
                            });
                        }).catch(error => {
                            this.$notify({
                                title: this.$t('error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                            this.isLoading = false;
                        });
                    }
                });
            },
            rejectCasePopUp() {
                this.$confirm(
                    this.$t('Are you sure want to reject this case?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    this.dialogFormVisible = true;
                }).catch(() => {});
            },
            reOpenCase() {
                this.$confirm(
                    this.$t('Are you sure want to re-open this case?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "update-case-status",
                            method: "post",
                            data: {
                                case_id: this.$route.params.id,
                                status: 'stage_1'
                            }
                        })
                        .then(response => {
                            this.$router.push({
                                name: 'Cases'
                            });
                            this.$notify({
                                title: this.$t('Success'),
                                message: this.$t('Case re-open successfully!'),
                                type: "success",
                                offset: 50
                            });
                        }).catch(error => {
                            this.$notify({
                                title: this.$t('error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                }).catch(() => {});
            },
            printDiv(divName) {
                // Get HTML to print from element
                const prtHtml = document.getElementById(divName).innerHTML;

                // Get all stylesheets HTML
                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML;
                }

                // Open the print window
                // const WinPrint = window.open('', '_blank');
                // var doc = new jsPDF();
                // const doc = new jsPDF({
                //     unit: "in",
                //     format:  [3, 5]});
                const doc = new jsPDF('l', 'mm', [297, 210]);
                var element = document.getElementById('pdfDiv').innerHTML;
                doc.html(element,{
                    callback: function (doc) {
                    doc.save('case_document.pdf');
                    // doc.output('dataurlnewwindow');
                },
                x: 10,
                y: 10,
                width: 210,
                    height: 297,
                    html2canvas: { scale: 0.25 },
                    // windowWidth: 1000,
                    // windowHeight: 2000
                });
                // WinPrint.document.write(`<!DOCTYPE html>
                // <html>
                // <head>
                //     ${stylesHtml}
                // </head>
                // <body>
                //     ${prtHtml}
                // </body>
                // </html>`);

                // WinPrint.document.close();
                // WinPrint.focus();
                // WinPrint.print();
                // setTimeout(() => {
                //     WinPrint.close();
                // }, 1000);
            },
            closeTab () {
                WinPrint.close();
            },
            addComment(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "case/" + this.$route.params.id + "/comments",
                                method: "post",
                                data: {
                                    comment: this.chatForm.chatDesc,
                                    is_admin: 1
                                }
                            })
                            .then(response => {
                                let commentData = response.data.data;
                                // this.enjoyhint_instance.trigger('next');
                            });
                        this.$refs[formName].resetFields();
                    }
                });
            },
            setEditAtt() {
                this.caseChats = this.caseChats.map(v => {
                    this.$set(v, 'edit', false);
                    this.$set(v, 'reply', false);
                    this.$set(v, 'replyForm', {
                        id: v.id,
                        commentDesc: null
                    });
                    if (v.children.length > 0) {
                        v.children.map(c => {
                            this.$set(c, 'edit', false)
                            return c
                        });
                    }
                    return v
                });
            },
            handleCommand(command) {
                if (command.type == 'edit') {
                    this.cancelEdit(this.dummyRow)
                    this.currentRow = Object.assign({}, command.row);
                    this.dummyRow = command.row;
                    command.row.edit = !command.row.edit;
                } else if (command.type == 'delete') {
                    this.deleteComment(command.row);
                }
            },
            cancelEdit(row) {
                row.edit = false;
                Object.assign(row, this.currentRow);
            },
            confirmEdit(row) {
                row.edit = false
                request({
                    url: "case/" + this.$route.params.id + "/comments/" + row.id,
                    method: "PATCH",
                    data: row
                }).then(response => {}).catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.response.data.message,
                        type: "error",
                        offset: 50
                    });
                });
            },
            deleteComment(row) {
                this.$confirm(
                    this.$t('Are you sure want to delete this comment?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('Yes'),
                        cancelButtonText: this.$t('No'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "case/" + this.$route.params.id + "/comments/" + row.id,
                            method: "delete",
                            data: {}
                        })
                        .then(response => {})
                        .catch(error => {});
                });
            },
            openCloseChat() {
                if(this.$route.query.chat) {
                    if(this.chat.drawer == true) {
                        this.chat.drawer = false;
                    } else {
                        this.chat.drawer = true
                    }
                } else {
                    this.$router.push({name:'CaseDetails',params:{id:this.$route.params.id},query: { chat: 1 }})
                }
            }
            // addReply(formName, replyData, formData) {
            //     this.$refs[formName][0].validate(valid => {
            //         if (valid) {
            //             request({
            //                     url: "case/" + this.$route.params.id + "/comments" + "?is_admin=1",
            //                     method: "post",
            //                     data: {
            //                         comment: formData.commentDesc,
            //                         parent_id: formData.id
            //                     }
            //                 })
            //                 .then(response => {
            //                     // this.enjoyhint_instance.trigger('next');
            //                     let res = response.data.data
            //                 });
            //             this.$refs[formName][0].resetFields();
            //         }
            //     });
            // },
        }
    }

</script>

<style scoped>
    .chatUser1 {
        border-radius: 6px;
        padding: 8px 10px;
        float: left;
        position: relative;
        color:#6c6c6c;
        background: rgba(0, 114, 135, .1);
        border: 2px solid rgba(0, 114, 135, .1);
        display: flex;
        flex-direction: column;
        max-width:80%;
    }
    .chatUser2 {
        background-color: #e5e5e5;
        position: relative;
        border-radius: 6px;
        padding: 8px 10px;
        float: right;
        max-width:80%;
        background: rgba(100, 170, 0, .1);
        border: 2px solid rgba(100, 170, 0, .1);
        display: flex;
        flex-direction: column;
        direction: rtl;
    }
    .avatar-icon {
        height: 35px;
        width: 35px;
        display: block;
        vertical-align: top;
        border-radius: 100%;
        overflow: hidden;
        border: 2px solid #ccc;
        margin-right: 10px;
    }
    .comment-div{
        margin: 5px 0 0 !important;
    }
    .box-card.reply-box  .avatar-dev .user-name{
        font-size:100%;
    }
    .box-card.reply-box .avatar-dev .user-name .comment-duration{
        font-size: 74%;
    }
    .avatar-icon img {
        max-width: 100%;
        min-height: 31px;
    }
    .comment-div{
        font-size:13px;
    }
    .reply-comments {
        width: 100%;
        overflow: auto;
    }

    .reply-comments .box-card {
        width: 95%;
        float: right;
    }

    .replyForm {
        width: 100%;
        display: inline-block;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .operations {
        transform: rotate(90deg);
        position: absolute;
        right: 6px;
        top: 12px;
        padding: 10px;
        cursor: pointer;
        color: #616161;
    }

    .operations i {
        font-size: 118.75%;
    }
    .cust-tabs,.case-vote-temp{
        position: relative;
    }
    .chat-box{
        position: absolute;
        right: 0;
        top: 8px;
        z-index: 99;
    }
    .chat-box .chat-icon{
        font-size: 1.5rem;
        color: #626262;
        display: block;
        text-align: right;
    }
    .chat-box span{
       color: #626262;
        font-size: 14px;
        font-weight: 600;
    }
    .box-card.el-card{
        border:none;
    }
    .chatUser2 .comment-div p{
        padding-right:30px;
        direction: ltr;
        padding-left: 0;
    }
    .chatUser2 .avatar-icon{
        margin-left: 9px;
    }
    .chatUser1 .avatar-icon{
        margin-right: 0;
    }
   .el-drawer__header .el-drawer__close-btn{
        background: #7f7f7d; 
        color: #fff;
        border-radius: 50%;
        /* padding: 4px 4px 2px 4px;
        font-size: 1rem; */
        font-size: 0.9rem; 
        text-align: center;
        padding: 3px 3px 3px 4px;
        
    }
    .no-discuss{
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #6c6c6c;
    }
    @media  screen and (max-width:767px){
        .chat-box{
            top: -12px;
        }
        .chat-box .chat-icon{
            font-size: 2rem;
        }
        .chat-box span{
            font-size:15px;
        }
    }
    

</style>



// WEBPACK FOOTER //
// src/components/Layout/Cases/CaseDetails.vue